module.exports = __webpack_public_path__ + "static/media/logo_white.ee305424.png";